/** Matches draft URL timestamp segments, e.g. 2026-06-01-06-58-17 */
const DRAFT_URL_TIMESTAMP_PART = /^\d{4}-\d{2}-\d{2}-\d{2}-\d{2}-\d{2}$/;

/**
 * Extract invoice external IDs encoded in a message draft UID.
 *
 * Supports:
 * - `{org}/msg/{timestamp}_{id1}_{id2}` (MSG_URL_PREFIX like "msg/")
 * - `{org}/msg_draft_{timestamp}_{id1}_{id2}` (default MSG_URL_PREFIX)
 */
export const parseInvoiceExternalIdsFromDraftUrl = (
  draftUrl: string,
): string[] => {
  const lastSegment = draftUrl.split("/").filter(Boolean).at(-1);
  if (!lastSegment) return [];

  const parts = lastSegment.split("_").filter(Boolean);
  const timestampIndex = parts.findIndex((part) =>
    DRAFT_URL_TIMESTAMP_PART.test(part),
  );

  if (timestampIndex !== -1) {
    return parts.slice(timestampIndex + 1);
  }

  // Fallback for legacy segments without a recognizable timestamp token
  if (parts.length <= 3) return [];
  return parts.slice(3);
};
